var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { withTranslation } from 'react-i18next';
var ScaleSlider = /** @class */ (function (_super) {
    __extends(ScaleSlider, _super);
    function ScaleSlider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.knobElement = null;
        _this.wrapperElement = null;
        _this.isMoving = false;
        _this.latestValue = null;
        return _this;
    }
    ScaleSlider.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { ref: function (ref) { return _this.wrapperElement = ref; }, className: "c-scale-slider", onPointerDown: function (event) { return _this.handlePointerDown(event); }, onPointerMove: function (event) { return _this.handlePointerMove(event); }, onPointerUp: function (event) { return _this.handlePointerUp(event); }, onPointerLeave: function (event) { return _this.handlePointerUp(event); }, onPointerCancel: function (event) { return _this.handlePointerUp(event); } },
            React.createElement("div", { ref: function (ref) { return _this.knobElement = ref; }, className: "c-scale-slider__knob", style: this.getKnobStyle() },
                React.createElement("div", { className: "c-scale-slider__knob__title" },
                    React.createElement("span", null, this.props.t('order.products.control.zoom.title'))),
                React.createElement("i", { className: "icon-magnifier" }))));
    };
    ScaleSlider.prototype.handlePointerDown = function (event) {
        if (this.isMoving) {
            return;
        }
        this.latestValue = this.props.value;
        this.isMoving = true;
        this.setValueByPosition(event);
        this.updateKnobPosition();
        this.props.onChange(this.latestValue);
    };
    ScaleSlider.prototype.handlePointerMove = function (event) {
        event.stopPropagation();
        if (!this.isMoving) {
            return;
        }
        this.setValueByPosition(event);
        this.updateKnobPosition();
        this.props.onChange(this.latestValue);
    };
    ScaleSlider.prototype.handlePointerUp = function (event) {
        event.stopPropagation();
        if (!this.isMoving) {
            return;
        }
        this.isMoving = false;
        this.props.onFinished(this.latestValue);
        this.latestValue = null;
    };
    ScaleSlider.prototype.setValueByPosition = function (event) {
        var position = this.getCursorPosition(event);
        if (!position) {
            return;
        }
        this.setValue(position);
    };
    ScaleSlider.prototype.getCursorPosition = function (event) {
        if (!this.wrapperElement) {
            return null;
        }
        var clientRect = this.wrapperElement.getBoundingClientRect();
        return event.clientX - clientRect.x;
    };
    ScaleSlider.prototype.updateKnobPosition = function () {
        if (!this.knobElement) {
            return;
        }
        var position = this.getKnobPosition();
        this.knobElement.style.left = position * 100 + "%";
    };
    ScaleSlider.prototype.getKnobPosition = function () {
        var _a;
        var value = (_a = this.latestValue) !== null && _a !== void 0 ? _a : this.props.value;
        return (value - this.props.minValue) / (this.props.maxValue - this.props.minValue);
    };
    ScaleSlider.prototype.setValue = function (position) {
        if (!this.wrapperElement) {
            return;
        }
        var width = this.wrapperElement.clientWidth;
        if (position < 0) {
            this.latestValue = this.props.minValue;
            return;
        }
        if (position >= width) {
            this.latestValue = this.props.maxValue;
            return;
        }
        var ratio = position / width;
        this.latestValue = this.props.minValue + (this.props.maxValue - this.props.minValue) * ratio;
    };
    ScaleSlider.prototype.getKnobStyle = function () {
        var position = this.getKnobPosition();
        return {
            left: position * 100 + "%",
        };
    };
    return ScaleSlider;
}(React.Component));
export default withTranslation()(ScaleSlider);
